(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // popout--groupクラス内のpopout__toggleを選択
    const popoutToggle = document.querySelector('.popout--group .popout__toggle');
    popoutToggle.addEventListener('click', function () {
      // PCのみで実行（画面幅が450pxより大きい場合）
      if (window.innerWidth > 450) {
        // aria-expandedの状態を確認
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        if (!isExpanded) {
          // ポップアウトが開かれる
          closeMenu();
        } else {
          // ポップアウトが閉じられる時
          openMenu();
        } //aria-expandedの値を反転（この部分はすでに他のJSで処理されている可能性あり）
      }
    });

    // ESCキーでポップアウトが閉じられた場合にもスクロールを復元（PCのみ）
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && window.innerWidth > 450) {
        closeMenu();
      }
    });

    const mainContent = document.getElementById('MainContent');
    let scrollY = 0;

    function openMenu() {
      scrollY = window.scrollY;
      mainContent.style.top = `-${scrollY}px`;
      mainContent.classList.add('fixed');
    }

    function closeMenu() {
      mainContent.classList.remove('fixed');
      mainContent.style.top = '';
      window.scrollTo(0, scrollY);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const popoutToggle = document.querySelector('.popout--group .popout__toggle');

    if (!popoutToggle || window.innerWidth > 768) return;

    const observer = new MutationObserver(function () {
      const isExpanded = popoutToggle.getAttribute('aria-expanded') === 'true';
      document.body.classList.toggle('filter-expanded', isExpanded);
    });

    observer.observe(popoutToggle, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });

    // 初期状態も反映
    const initial = popoutToggle.getAttribute('aria-expanded') === 'true';
    document.body.classList.toggle('filter-expanded', initial);
  });

  } catch(e) { console.error(e); }
})();
})();
